const isVehicleOlderThan = (vehicleYear, n) => {
    if (typeof vehicleYear !== 'number') {
        if (typeof vehicleYear === 'string' && /^\d+$/.test(vehicleYear)) {
            vehicleYear = parseInt(vehicleYear, 10);
        } else {
            return false;
        }
    }
    if (typeof n !== 'number') {
        if (typeof n === 'string' && /^\d+$/.test(n)) {
            n = parseInt(n, 10);
        } else {
            return false;
        }
    }

    const currentYear = new Date().getFullYear();
    return (currentYear - vehicleYear) > n
}

export default isVehicleOlderThan;